module.exports = function getResource(label, vars = []) {
    let resources = {
        pinchAndZoom: 'Pinch and zoom',
        pinchToZoom: 'Pinch to zoom'
    };

    return resources[label];
};
